import { get } from 'core_main/request';
import { updateStore } from 'core_main/store';
import {
  makeGetChatSettingsEndpoint,
  makeGetChatSettingsVersionEndpoint,
} from './helpers';
import { FetchSettingsParameters } from './types';

const fetchLatestSettingsVersion = (brandId?: string) => {
  return get(makeGetChatSettingsVersionEndpoint({ brandId }))
    .then((res) => res?.data.attributes.settingsVersion)
    .catch(() => {
      // if the call to /versions fails, it's ok to just swallow the error
      // because /settings can be called without the version param
      return undefined;
    });
};

export const fetchSettings = (parameters: FetchSettingsParameters) => {
  return fetchLatestSettingsVersion(parameters.brandId).then(
    (settingsVersion) =>
      get(
        makeGetChatSettingsEndpoint({
          brandId: parameters.brandId,
          lang: parameters.lang,
          settingsVersion,
        }),
      ).then((response) => {
        const {
          assistantRules,
          botConsent,
          closableChat,
          colors,
          disableAttachments,
          domainCriteria,
          embedIconColor,
          embedIconUrl,
          enabled,
          greeting,
          noHistory,
          offhoursDisplay,
          offhoursImageUrl,
          offhoursMessage,
          outboundChatEnabled,
          sentry,
          sharedPubNubKeySet,
          showBotIdentifier,
          showBrandingIdentifier,
          showTypingIndicatorCustomerWeb,
          showTypingIndicatorWeb,
          singleSessionChat,
          teamIconUrl,
          teamName,
          volumeControl,
          waitMessage,
          widgetType,
        } = response.data.attributes;

        const { id: orgId } = response.data.relationships.org.data;
        const brandId = response?.data?.relationships?.brand?.data?.id;
        const knowledgeBaseId = response?.data?.relationships?.kb?.data?.id;
        const activeAssistant =
          parameters?.assistantId ||
          response?.data?.attributes?.activeAssistant;

        updateStore('settings', {
          activeAssistant,
          assistantRules,
          botConsent,
          brandId,
          closableChat,
          colors,
          disableAttachments,
          domainCriteria,
          embedIconColor,
          embedIconUrl,
          enabled,
          greeting,
          knowledgeBaseId,
          noHistory,
          offhoursDisplay,
          offhoursImageUrl,
          offhoursMessage,
          outboundChatEnabled,
          sentry,
          sharedPubNubKeySet,
          showBotIdentifier,
          showBrandingIdentifier,
          showTypingIndicatorCustomerWeb,
          showTypingIndicatorWeb,
          singleSessionChat,
          teamIconUrl,
          teamName,
          volumeControl,
          waitMessage,
          widgetType,
        });

        updateStore('orgId', orgId);

        return response;
      }),
  );
};
